export { IAnimationStyles, IAnimationVariables } from './IAnimationStyles';
export { IEffects } from '@fluentui/theme/lib/types/IEffects';
export { IGetFocusStylesOptions } from './IGetFocusStyles';
export { IFontStyles } from '@fluentui/theme/lib/types/IFontStyles';
export { IPalette } from '@fluentui/theme/lib/types/IPalette';
export { ISemanticColors } from '@fluentui/theme/lib/types/ISemanticColors';
export { ISemanticTextColors } from '@fluentui/theme/lib/types/ISemanticTextColors';
export { ISpacing } from '@fluentui/theme/lib/types/ISpacing';
export { ITheme, IPartialTheme, IScheme, ISchemeNames } from '@fluentui/theme/lib/types/ITheme';
